













import Vue from "vue";
import Helpers from "@/helpers";

export default Vue.extend({
  name: "Header",
  methods: {
    navigateToSection(sectionId: string) {
      if (this.$route.path === "/") {
        Helpers.scrollToSection(sectionId);
        return;
      }

      Helpers.queueSectionScroll(sectionId);
      this.$router.push("/");
    }
  }
});
